import React, { useEffect, useState } from "react";
import { getUser, } from '../../utils/Common';
import '../../estilos/dashboardStyle.css';
import image from '../../assets/girasol.jpg'

function Dashboard(props) {
    const user = getUser();

    useEffect(() => { }, []);

    const redirect = (ruta) => {
        props.history.push(ruta);
    }
    return (
        <div className="w-100 p-0 m-0 round-m " style={{ height: "calc(100vh - 60px)", backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center', overflow: 'auto' }}>
            <div className='row justify-content-evenly m-0 p-0 w-100'>
                <div className="round-top-m p-2 bg-white3 blur-xxl" style={{ height: '35px' }}>
                    <p className="">
                        <span className="h4 text-bold text-black">INICIO</span>
                        <span className="ml-2 text-black text-sm">Acceso rapido a las diferentes secciones</span>
                    </p>
                </div>
                <div className='col-lg-12 mt-2'></div>
                {
                    user.menus.map((menu, i) => {
                        return (
                            <div key={"meni" + i} className={'main-item-menu m-2 p-1 round-s shadow-multi-sm contenedor  blur-xxl' + (
                                menu.subMenus.length === 0 ? ' scale-05 border select-color-old pointer ' : ""
                            )} onClick={() => { if (menu.url !== "#") redirect(menu.url) }}>
                                <div className={'row justify-content-center m-0 p-0'}>
                                    <div className='col-lg-12 text-center h4 text-300 m-0 p-0 ' >{menu.nombre}</div>
                                    {menu.subMenus.length > 0 && <div className='col-lg-12 m-0 p-0'>
                                        <div className='row justify-content-evenly'>
                                            {
                                                menu.subMenus.map((sub, j) => {
                                                    return (
                                                        <div className={'w-90 p-1 text-center shadow-sm m-1 mb-2 mt-2round-s scale-05 pointer select-color' + (menu.nombre.toLowerCase() === 'vivero' ? '' : '-old')} key={'uri' + j}
                                                            onClick={() => { redirect(sub.url) }}>{sub.nombre}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>}

                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Dashboard;
